// Kleine Bedienhilfen fuer das Handy, auf allen Seiten.
//
// (8) „In den Warenkorb": Horizon zeigt erst nach dem Server-Rueckruf einen Haken und oeffnet
//     dann die Schublade - auf einem gedrosselten Handy vergehen bis dahin 1-3 s ohne sichtbare
//     Reaktion, und man tippt ein zweites Mal. Jetzt dreht sofort ein Ladekreis im Knopf, bis
//     Haken oder Schublade da sind; ein zweiter Tipp wird solange ignoriert.
//
// (11) Warenkorb-Schublade auf kleinen Handys (iPhone SE): Artikel und Kassenbereich scrollen
//     gemeinsam, „Zur Kasse" lag unterhalb des Bildschirms. Beim Oeffnen wird die Schublade so
//     weit gerollt, dass der Knopf ganz im Bild ist.
(function () {
  'use strict';

  // ---------- (8) Ladekreis ----------
  function fertig(knopf) {
    if (!knopf || !knopf.classList.contains('s-adding')) return;
    knopf.classList.remove('s-adding');
    if (knopf._sBeobachter) { knopf._sBeobachter.disconnect(); knopf._sBeobachter = null; }
    clearTimeout(knopf._sZeit);
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest && e.target.closest('product-form-component button[type="submit"]');
    if (!knopf || knopf.disabled || knopf.classList.contains('s-adding')) return;
    // erst nach Horizons eigenem Klick-Handler markieren, damit der Klick normal durchgeht
    setTimeout(function () {
      knopf.classList.add('s-adding');
      knopf._sBeobachter = new MutationObserver(function () {
        if (knopf.dataset.added === 'true') fertig(knopf);
      });
      knopf._sBeobachter.observe(knopf, { attributes: true, attributeFilter: ['data-added'] });
      knopf._sZeit = setTimeout(function () { fertig(knopf); }, 8000);   // Sicherheitsnetz
    }, 0);
  }, true);

  // Lehnt der Server das Hinzufuegen ab, stand neben der Fehlermeldung trotzdem ein Haken im Knopf:
  // Horizon zeigt ihn schon beim Tippen, vor der Antwort. Bei einem Fehler verschwindet er jetzt sofort.
  // (Capture, weil das Ereignis nicht in jedem Fall nach oben durchgereicht wird.)
  document.addEventListener('shopify:cart:error', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('product-form-component') : null;
    (form || document).querySelectorAll('button[data-added="true"], button.s-adding').forEach(function (k) {
      k.removeAttribute('data-added');
      fertig(k);
    });
  }, true);

  // ---------- (11) „Zur Kasse" ins Bild holen ----------
  function zeigeKasse(dialog) {
    if (window.innerWidth >= 750 || window.innerHeight > 700) return;
    [450, 1200].forEach(function (verzoegerung) {   // die Schublade baut ihren Inhalt nach
      setTimeout(function () {
        if (!dialog.open) return;
        var knopf = dialog.querySelector('.cart__checkout-button');
        var rolle = dialog.querySelector('.cart-drawer__content');
        if (!knopf || !rolle) return;
        var kr = knopf.getBoundingClientRect(), rr = rolle.getBoundingClientRect();
        var fehlt = kr.bottom - rr.bottom + 12;
        if (fehlt > 0) rolle.scrollTo({ top: rolle.scrollTop + fehlt, behavior: 'smooth' });
      }, verzoegerung);
    });
  }

  // Horizons Schublade: <dialog class="theme-drawer__dialog"> liegt AUSSEN um cart-drawer-component.
  function istWarenkorb(d) {
    return d && d.tagName === 'DIALOG' && !!d.querySelector('cart-drawer-component, .cart-drawer__inner, .cart__checkout-button');
  }
  var beobachter = new MutationObserver(function (liste) {
    liste.forEach(function (m) {
      var e = m.target;
      if (m.attributeName === 'open' && e.open && istWarenkorb(e)) {
        zeigeKasse(e);
        // Schublade ist offen - der Ladekreis im Kaufknopf hat ausgedient
        document.querySelectorAll('button.s-adding').forEach(fertig);
      }
      // Horizon setzt data-added kurz auf "true", wenn der Artikel drin ist (Haken im Knopf)
      if (m.attributeName === 'data-added' && e.dataset && e.dataset.added === 'true') {
        document.querySelectorAll('button.s-adding').forEach(fertig);
      }
    });
  });
  beobachter.observe(document.documentElement, { attributes: true, attributeFilter: ['open', 'data-added'], subtree: true });
})();
